import {Backbone} from 'Vertebrae';
import {Employer} from '../model/employer';

export const Employers = Backbone.Collection.extend({
    _name: 'Employers',
    model: Employer,
});
